export default {
   "oscode": "",
   "osdesc": "",
}
